import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

export const track = (event, params = {}) => {
  if (window.gtag) window.gtag("event", event, params);
};

const loadGtag = () => {
  if (!GA_ID || window.gtag) return;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", GA_ID, { send_page_view: false });
};

export const useAnalytics = () => {
  const { pathname } = useLocation();

  useEffect(loadGtag, []);

  useEffect(() => {
    if (!GA_ID) return;
    const t = setTimeout(() => {
      track("page_view", { page_path: pathname, page_title: document.title, page_location: window.location.href });
    }, 300);
    return () => clearTimeout(t);
  }, [pathname]);
};
